import { Box, Button, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import { ROLES } from "../../../constants";
import { useReadAndAcknowledgeMutation } from "../../../generated/graphql";
import useAppStore from "../../../states/zustand/appStore";
import useAuthStore from "../../../states/zustand/authStore";
import { getFileName } from "../../../utils/helper";
import Moment from "../Moment/Moment";
import styles from "./ReadReviewDialog.module.scss";
import { useParams } from "react-router-dom";

interface IDoc {
  _id: string;
  url: string;
  remark?: string | null | undefined;
  createdAt: string;
  readAndAcknowledge: boolean;
}
const File: FC<{
  doc: IDoc;
  docId: any;
  submissionType?: string;
  getDocStack?: Function;
}> = (props): JSX.Element => {
  const { doc, docId, getDocStack, submissionType } = props;
  const { id } = useParams() as any;
  const [makeReadAndAcknowledge, { loading: readLoader }] =
    useReadAndAcknowledgeMutation();
  const { setLoader } = useAppStore();
  const {
    profileData: { role },
  } = useAuthStore();
  const makeRead = async () => {
    setLoader(true);
    if (submissionType) {
      await makeReadAndAcknowledge({
        variables: {
          docStackId: doc._id,
          readAndAcknowledge: true,
          submissionId: id,
          submissionType,
        },
      });
    }

    getDocStack &&
      getDocStack({
        variables: {
          docId: docId,
        },
      });
  };

  const isDisabled = useMemo(() => {
    return [ROLES.INVESTIGATOR].includes(role) || readLoader;
  }, [role, readLoader]);

  return (
    <>
      <Box className={`${styles.reviewFileBox} mg-b-20`}>
        <i className={`${styles.iconLeft} icon-paper`}></i>
        <Typography
          variant={"body1"}
          component={"p"}
          className={`font-weight-semi-bold`}
        >
          {getFileName(doc?.url)}
        </Typography>
        <Typography
          variant={"body2"}
          component={"p"}
          className={`${styles.dates}`}
        >
          <Moment date={doc?.createdAt} format="h:mm A, MMM DD, YYYY"/>
        </Typography>
        <a href={doc?.url} download target="_blank">
          <button
            type={"button"}
            className={`btn btn-link ${styles.btnAction}`}
          >
            <i className={`icon-download`}></i>
          </button>
        </a>
      </Box>

      <Box className={`mg-b-20`}>
        {doc?.readAndAcknowledge ? (
          <Button
            className={`mg-r-10`}
            variant={"contained"}
            color={"success"}
            size={"small"}
          >
            <i className={`icon-done-outline mg-r-10`}></i>
            Read & Acknowledge
          </Button>
        ) : (
          <Button
            className={`mg-r-10`}
            disabled={isDisabled}
            onClick={makeRead}
            variant={"outlined"}
            color={"error"}
            size={"small"}
          >
            Read & Acknowledge?
          </Button>
        )}
        {doc?.remark ? (
          <Typography className={`mg-t-15`} color={"secondary"}>
            Remark: {doc.remark}
          </Typography>
        ) : null}
      </Box>
    </>
  );
};

export default File;
